/**
 * /admin/billing — Subscription billing (route shell).
 * Screen impl in `./billing-screen.tsx`, lazy-loaded.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/billing')({
  component: lazyRouteComponent(
    () => import('./billing-screen'),
    'AdminBilling',
  ),
});
